import { regex } from '../config/globals'

export const clearCookies = (res, cookies) => {
    cookies.forEach(cookie => {
        res.clearCookie(cookie)
    })
}

/**
 * the vanilla cookie getters and setters below should not be used server-side
 * in the future could update with a package if desired
*/
export const getCookie = (name) => {
    if (typeof document === 'undefined') {
        return null
    }
    const cookie = document.cookie.match(regex.cookie.replace('name', name))
    return cookie ? cookie[2] : null
}

export const setCookie = (name, value, path = '/', maxAge = null) => {
    const cookiePath = path ? `; path=${path}` : ''
    const cookieMaxAge = maxAge ? `; max-age=${maxAge}` : ''
    document.cookie = `${name}=${value}${cookiePath}${cookieMaxAge}`
}

export const updateCookie = (name, value, path = '/', maxAge = null) => {
    getCookie(name) && setCookie(name, value, path, maxAge)
}

export const deleteCookie = (name) => {
    setCookie(name, '', '/', -1)
}

export const getCartId = () => {
    if (typeof document === 'undefined') {
        return null
    }
    var cartIdMatch = document.cookie.match(/cartId=([^;]+)/)
    var cartId = cartIdMatch ? cartIdMatch[1] : undefined
    return cartId
}
